import i18next from 'i18next';
export { default as lang } from './lang.es.js';

const NAMESPACE = 'ecommerce';
const t = (keys, options) => {
    const text = i18next.t(keys, Object.assign(Object.assign({}, options), { ns: NAMESPACE, interpolation: { escapeValue: false } }));
    return text || keys;
};

export { NAMESPACE, t };
